// extracted by css-extract-rspack-plugin
export default {"icon":"Gdk35","tab":"r8I33"};